import { InputVariantType } from '../../../../../../components/inputV2/types/inputVariantType';
import { InputDecorationVariantType } from '../../inputDecoration/variants';
import { commonStyles } from '../commonStyles';
const commonStateStyles = {
    leftDecoration: { variant: InputDecorationVariantType.MAIN_SECTION },
    rightDecoration: { variant: InputDecorationVariantType.MAIN_SECTION },
    clearIcon: { variant: InputDecorationVariantType.MAIN_SECTION },
};
export const getInputMainSectionStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputVariantType.MAIN_SECTION]: {
            ...commonStyles(FOUNDATIONS, {
                ["FOCUSED" /* InputStateType.FOCUSED */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_neutral_bg_mainsection_50,
                        outline: `${FOUNDATIONS.color_accent_active_primary_border_mainsection_50} solid ${FOUNDATIONS.border_100}`,
                        outline_color: FOUNDATIONS.color_accent_active_primary_border_mainsection_50,
                    },
                },
                ["EMPTY" /* InputStateType.EMPTY */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_neutral_bg_mainsection_50,
                        border_color: FOUNDATIONS.color_neutral_border_mainsection_50,
                    },
                },
                ["FILLED" /* InputStateType.FILLED */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_neutral_bg_mainsection_50,
                        border_color: FOUNDATIONS.color_neutral_border_mainsection_100,
                    },
                },
                ["ERROR_EMPTY" /* InputStateType.ERROR_EMPTY */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_feedback_error_bg_mainsection_50,
                        outline: `${FOUNDATIONS.color_feedback_error_border_mainsection_50} solid ${FOUNDATIONS.border_100}`,
                    },
                },
                ["ERROR_FILLED" /* InputStateType.ERROR_FILLED */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_feedback_error_bg_mainsection_100,
                        outline: `${FOUNDATIONS.color_feedback_error_border_mainsection_50} solid ${FOUNDATIONS.border_100}`,
                    },
                },
                ["DISABLED_EMPTY" /* InputStateType.DISABLED_EMPTY */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_mainsection_100,
                    },
                },
                ["DISABLED_FILLED" /* InputStateType.DISABLED_FILLED */]: {
                    ...commonStateStyles,
                    inputContainer: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_mainsection_100,
                    },
                },
            }),
        },
    };
};
//# sourceMappingURL=mainSection.js.map